import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=e50eb494&"
import script from "./ModalContainer.vue?vue&type=script&lang=js&"
export * from "./ModalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ef2/Projecten/vue-components/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e50eb494')) {
      api.createRecord('e50eb494', component.options)
    } else {
      api.reload('e50eb494', component.options)
    }
    module.hot.accept("./ModalContainer.vue?vue&type=template&id=e50eb494&", function () {
      api.rerender('e50eb494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ModalContainer.vue"
export default component.exports